import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA/Offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[SW] Service worker registration failed:', err?.message);
    });
  });
}

// Cleanup old cached data on startup
import('./lib/db').then(({ cleanupOldCache }) => {
  cleanupOldCache();
}).catch((err) => {
  console.warn('[DB] Cache cleanup import failed:', err?.message);
});
